import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC, MouseEvent } from 'react';
import { DecisionSearchScope } from './DecisionSearchProvider';

interface DecisionSearchScopeSelectorProps {
    analysisAvailable: boolean;
    onChange: (scope: DecisionSearchScope) => void;
    value: DecisionSearchScope;
}

const DecisionSearchScopeSelector: FC<DecisionSearchScopeSelectorProps> = ({
    analysisAvailable,
    onChange,
    value,
}) => {
    const { t } = useTranslation('search');

    const handleChange = (_event: MouseEvent<HTMLElement>, scope: DecisionSearchScope | null) => {
        if (scope) onChange(scope);
    };

    return (
        <ToggleButtonGroup
            aria-label={t('documentSearchScope.label')}
            onChange={handleChange}
            size="small"
            value={value}
            exclusive
        >
            <ToggleButton value="decision">{t('documentSearchScope.decision')}</ToggleButton>
            <ToggleButton disabled={!analysisAvailable} value="analysis">
                {t('documentSearchScope.analysis')}
            </ToggleButton>
        </ToggleButtonGroup>
    );
};

export default DecisionSearchScopeSelector;
